import { render, staticRenderFns } from "./BISSelection.vue?vue&type=template&id=e84ce028&scoped=true&"
import script from "./BISSelection.vue?vue&type=script&lang=js&"
export * from "./BISSelection.vue?vue&type=script&lang=js&"
import style0 from "./BISSelection.vue?vue&type=style&index=0&id=e84ce028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84ce028",
  null
  
)

export default component.exports